import React, { Component } from "react";

import Modal from "../../Components/UI/Modal/Modal";
import ApparelsOptions from "./ApparelsOptions/ApparelsOptions";
import apprarIcon from "../../assets/Img/apparels.png";

class Apparels extends Component {
  state = {
    // ################### ERROR MODAL:
    showErrorModal: false,
    formErrorMessage: null,
    //done:
    done: false,
  };
  //##################################################### Error MODAL METHODS :

  errorModalHandler = (errMess) => {
    this.setState((prevState) => {
      return {
        showErrorModal: !prevState.showErrorModal,
        formErrorMessage: errMess,
      };
    });
  };

  render() {
    return (
      <div>
        <Modal
          showModal={this.state.showErrorModal}
          closeModal={this.errorModalHandler}
        >
          <div>
            <h4 style={{ color: "red", textAlign: "center" }}>Invalid </h4>
            <p style={{ whiteSpace: "pre-wrap" }}>
              {this.state.formErrorMessage}
            </p>
          </div>
        </Modal>
        <h1 className="ModelHeadline my-5 text-center">
          APPARELS <img src={apprarIcon} alt="apparels" />
        </h1>
        <ApparelsOptions
          history={this.props.history}
          errorModalHandler={this.errorModalHandler}
        />
      </div>
    );
  }
}

export default Apparels;
